<template>
  <div class="queue-error-toast" @click="resetError">
    {{ $t('errors.title') }}
    <br />
    ({{error}})
  </div>
</template>

<script>
export default {
  methods: {
    resetError() {
      this.$store.commit("setError", null);
      this.$store.commit("preorder/setError", null);
    }
  },
  computed: {
    error() {
      return this.$store.state.error || this.$store.state.preorder.error;
    }
  }
};
</script>

<style scoped>
.queue-error-toast {
  width: 95vw;

  position: fixed;

  top: 5vh;

  margin: 0 auto;
  left: 0;
  right: 0;

  z-index: 5000;
  text-align: center;
  border-radius: 1vh;

  padding: 2vh 1vh;
  color: #ededed;
  background: #e2223b;
}
</style>